<template>
    <ldc-dialog
        :title="title"
        :colorTitle="colorTitle"
        :clickoutside="true"
        width="50%"
        :fullscreen="$detect == 'mobile'"
        :class="{
            'modal-register-vip': $detect == 'web',
            'modal-mobile-vip position-relative': $detect == 'mobile',
            'modal-vip' : action == 'vip',
            'modal-svip' : action == 'supper-vip',
            'modal-normal' : action == 'auto',
        }"
        :visible.sync="dialog">
        <div class="content-modal py-3 px-10px">
            <div class="d-flex">
                <div class="w-40">
                    <div class="name">
                        Tin rao:
                    </div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <a :href="$linkUrl(data.link)" class="text-decoration-none link-news"
                            v-if="!multiple" target="_blank">
                            {{data.name}}
                        </a>
                        <p class="mb-0 fw-600 text-primary link-news" v-else>
                            <span v-for="(item, index) in dataMultiple" :key="index">#{{item}}, </span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3" v-if="!multiple">
                <div class="w-40">
                    <div class="name">Loại tin:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <p class="vip mb-0 text-success" v-if="data.classify == 'vip'">VIP</p>
                        <p class="svip mb-0 text-warning" v-else-if="data.classify == 'supper_vip'">SIÊU VIP</p>
                        <p class="mb-0"  v-else-if="data.classify == 'often'">Thường</p>
                        <p class="vip mb-0 text-warning" v-else>SIÊU VIP<img src="/images/svip-pin.svg"/></p>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div class="w-40">
                    <div class="name">Phí:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <span class="text-danger fw-600">{{oneManipulation.money_text}} <span style="color: #212529;" class="fw-400">{{money.unit}}</span></span> /{{oneManipulation.unit}}
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div class="w-40">
                    <div class="name">Thời hạn:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <input type="text" class="input-time-vip mr-1 text-right"
                            v-model="amount" ref="input-action-dialog"
                            @focus="(e) => e.target.select()"/>
                        {{oneManipulation.unit}}
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div class="w-40">
                    <div class="name">Tổng:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <span class="text-danger fw-600 mr-2">{{$formatNumber(total)}} <span style="color: #212529" class="fw-400">{{money.unit}}</span></span>
                        <span class="text-warning noti-point mx-1 fs-12px"
                            v-if="total > money.money"
                            >* Không đủ {{money.unit}}</span>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div class="w-40">
                    <div class="name">Tài khoản có:</div>
                </div>
                <div class="w-60">
                    <div class="value">
                        <span class="text-danger fw-600 mr-2">{{money.money_text}} <span style="color: #212529" class="fw-400">{{money.unit}}</span></span>
                        <a href="https://vatgia.com/nap-tien.html" class="text-decoration-none recharge mx-1">(Nạp {{money.unit}})</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-modal text-center">
            <button :class="{
                    'btn btn-confirm my-10px mr-10px': true,
                    'btn-sm': $detect == 'web'
                }"
                :disabled="loading || amount <= 0 || total > money.money"
                @click="submit()"
                >Xác nhận</button>
        </div>
    </ldc-dialog>
</template>
<script>
export default {
    props: ['visible', 'data', 'action', 'multiple', 'dataMultiple'],
    data() {
        return {
            dialog: false,
            title: '',
            oneManipulation: {},
            colorTitle: '',
            amount: '',
            actionMuti: false,
            total: 0,
            loading: false,
            source_pay: this.$detect == 'web' ? 0: 1,
        }
    },
    watch: {
        visible(val){
            this.dialog = val;
        },
        dialog(val){
            getMoney();
            this.$emit('update:visible', val);
            if(val){
                this.total = 0;
                this.amount = '';
                setTimeout(() => {
                    this.$refs['input-action-dialog'].focus();
                }, 100)
            }
        },
        action(val){
            if(val == 'vip'){
                this.title = 'Up vip';
                this.oneManipulation = this.config.con_raovat_vip_price;
                this.colorTitle = 'rgb(40, 167, 69)';
            }else if(val == 'supper-vip'){
                this.title = 'Up siêu vip';
                this.oneManipulation = this.config.con_raovat_super_vip_price;
                this.colorTitle = '#ffc107';
            }else if(val == 'auto'){
                this.title = 'Up tự động';
                this.oneManipulation = this.config.con_raovat_up_price;
                this.colorTitle = '#0c81f6';
            }
        },
        amount(newVal, oldVal) {
            if(newVal * 1 == newVal && newVal % 1 == 0){
                if(newVal <= 1000){
                    if(this.actionMuti){

                    }else{
                        this.singleAction();
                    }
                }else{
                    this.amount = 1000;
                }
            }else{
                this.amount = oldVal;
            }
        }
    },
    computed: {
        config(){
            return this.$store.state.config;
        },
        money(){
            return this.$store.state.money;
        },
    },
    methods: {
        singleAction(){
            if(!this.multiple){
                this.total = this.amount * this.oneManipulation.money;
            }else{
                this.total = this.amount * this.oneManipulation.money * this.dataMultiple.length;
            }
        },
        submit(){
            if(!this.multiple){
                if(this.action == 'vip'){
                    this.upVip(this.data.id);
                }else if(this.action == 'supper-vip'){
                    this.upSupperVip(this.data.id);
                }
            }else{
                if(this.action == 'vip'){
                    this.upVipMuti();
                }else if(this.action == 'supper-vip'){
                    this.upSupperVipMuti();
                }
            }
        },
        async upVipMuti(){
            let error = [];
            let check = null;
            for (const key in this.dataMultiple) {
                check = await this.upVip(this.dataMultiple[key]);
                if(check){
                    error.push(check);
                }
            }
            this.loading = false;
            this.dialog = false;
            if(error.length == 0){
                this.$message({
                    message: 'Up vip thành công',
                    type: 'success',
                    center: true,
                });
            }else{
                let message = '';
                error.map(item => message += ' #'+item)
                this.$message({
                    message: 'Up vip không thành công với tin rao'+ message,
                    type: 'error',
                    center: true,
                    timeOut: 5000,
                    showClose: true,
                });
            }
        },
         async upSupperVipMuti(){
            let error = [];
            let check = null;
            for (const key in this.dataMultiple) {
                check = await this.upSupperVip(this.dataMultiple[key]);
                if(check){
                    error.push(check);
                }
            }
            this.loading = false;
            this.dialog = false;
            if(error.length == 0){
                this.$message({
                    message: 'Up siêu vip thành công',
                    type: 'success',
                    center: true,
                });
            }else{
                let message = '';
                error.map(item => message += ' #'+item)
                this.$message({
                    message: 'Up siêu vip không thành công với tin rao'+ message,
                    type: 'error',
                    center: true,
                    timeOut: 5000,
                    showClose: true,
                });
            }
        },
        async upVip(id){
            this.loading = true;
            let idReturn = null;
            await apiPost('/v2/profile/raovat/up_vip', {
                id: id,
                quantity: this.amount*1,
                source_pay: this.source_pay
            }).then(res => {
                let data = res.data;
                if(!this.multiple){
                    let type;
                    if(res.success == 1){
                        type = 'success';
                        this.dialog = false;
                        this.total = 0;
                        this.amount = '';
                        getMoney();
                    }else{
                        type = 'error';
                    }
                    this.$message({
                        message: res.message,
                        type: type,
                        center: true,
                    });

                    this.loading = false;
                }else{
                    if(res.success == 0) idReturn = id;
                }
            })
            return idReturn;
        },
        async upSupperVip(id){
            this.loading = true;
            let idReturn = null;
            await apiPost('/v2/profile/raovat/up_super_vip', {
                id: id,
                quantity: this.amount*1,
                source_pay: this.source_pay
            }).then(res => {
                let data = res.data;
                if(!this.multiple){
                    let type;
                    if(res.success == 1){
                        type = 'success';
                        this.dialog = false;
                        getMoney();
                    }else{
                        type = 'error'
                    }
                    this.$message({
                        message: res.message,
                        type: type,
                        center: true,
                    });
                    this.total = 0;
                    this.amount = '';
                    this.loading = false;
                }else{
                    if(res.success == 0) idReturn = id;
                }
            })
            return idReturn;
        }
    }
}
</script>
<style lang="scss">

</style>
